import { mapActions } from 'vuex';

export default {
  name: 'page-leave-message',
  props: ['widgetStyle', 'widgetConfig'],
  data() {
    return {
      message: 'Proszę o kontakt',
    };
  },
  computed: {
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
        borderColor: this.widgetStyle.main_color,
      };
    },
    messageLength() {
      return this.message.length;
    },
  },
  methods: {
    ...mapActions(['toggleWidgetModal', 'sendCallBackManuallyDisposition']),
    sendMessage() {
      this.sendCallBackManuallyDisposition(this.message);
    },
    validateMessageLength() {
      if (this.messageLength >= 255) {
        this.message = this.message.substr(0, 255);
      }
    },
  },
};
